/**
 * Construye el objeto `data` que espera <ShowDocument data={...} />
 * a partir de un path de url_path_whatsapp.
 *
 * ⚠️ Ajusta `url` y `method` al endpoint real que usa la plataforma
 * para "900114098-API-DOWNLOAD-BASE64" (no tengo esa info en el código compartido).
 */
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
export const buildDocumentItem = (path) => ({
    trigger: [
        {
            method: 'post',
            url: baseUrlFlow, // <-- confirmar URL real
            bodyData: {
                path,
                bucket: 'ia-automation-storage-staging',
                id_flow: '900114098-API-DOWNLOAD-BASE64',
            },
        },
    ],
});